/**
 *    @author: Andrew Sheen
 *    @since:  2021-03-10
 */

 import { Injectable } from '@angular/core';
 import { HttpClient } from "@angular/common/http";
 import { environment } from '../../environments/environment';
 
 @Injectable({
   providedIn: 'root',
 })
 
 export class EmailService {
 
        constructor(private http:HttpClient)  {}
        
        public send(emailData:EMailData, callback:Function ) {
         
               if ( environment.email_url.startsWith("assets/") ) {
                    callback( {success:true});
                    return;
               }
 
               this.http.post(environment.email_url,emailData)
                        .subscribe( (res) => {
                         callback(res);
               },
               error => {
                     ///console.log(error);
                     callback( {success:false});
               });             
        }
 }
 
export class EMailData {
       public receiver:string[] = [];
       public content:string;
       public type:number;
}

export class Status {
      public success:boolean;
}
